<div class="confirm-modal ig-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">ASSIGN TO REGION</div>

    <div *ngIf="!data.regions||!data.regions.length">
        <div class="empty-list">No regions, please create some regions firstly...</div>
    </div>

    <ng-container *ngIf="data.regions.length">
        <div #div class="full-width m-t-3">
            <div style="padding: 0 8px;text-align: left; height:250px;overflow-y: auto;">
                <div *ngFor="let region of data.regions">
                    <mat-checkbox [(ngModel)]="region.isInRegion"
                                  (ngModelChange)="toggle(region)">{{region.region.name}}
                    </mat-checkbox>
                </div>
            </div>
        </div>
    </ng-container>

    <ig-row *ngIf="data.regions.length" [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button class="btn-primary" color="primary" size="md" [isAsync]="true"
                       (trigger)="confirm($event)">
                Save
            </ig-button>
        </ig-col>
    </ig-row>
    <div class="cancel-btn" (click)="close()">
        Cancel
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/assign.tour.modal/assign.tour.modal.component.html